export default __webpack_public_path__ + "static/media/form-left.c65730f5.svg";